import type { AuthSession } from './types';

export const isSuperuserSession = (session: AuthSession | null): boolean => {
  if (!session) {
    return false;
  }

  return (session.roles ?? []).includes('superuser') && session.superuserEmailMatched === true;
};

export const hasScopedAdminAccess = (
  session: AuthSession | null,
  organisationId: string | null | undefined,
): boolean => {
  if (!session || !organisationId) {
    return false;
  }

  if (isSuperuserSession(session)) {
    return true;
  }

  if (!(session.roles ?? []).includes('admin')) {
    return false;
  }

  return session.orgId === organisationId || session.lastOrganisationId === organisationId;
};
